import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, withCtx as _withCtx, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5140352b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "qualification-dialog" }
const _hoisted_2 = { class: "qualification-dialog__header" }
const _hoisted_3 = {
  class: "qualification-dialog__icon qualification-dialog__icon--error",
  "aria-hidden": "true"
}
const _hoisted_4 = {
  viewBox: "0 0 24 24",
  width: "24",
  height: "24"
}
const _hoisted_5 = ["d"]
const _hoisted_6 = { class: "qualification-dialog__heading" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  id: "qualification-blocked-title",
  class: "qualification-dialog__title"
}, " Não é possível alocar este médico ", -1))
const _hoisted_8 = {
  key: 0,
  class: "qualification-dialog__chip"
}
const _hoisted_9 = {
  viewBox: "0 0 24 24",
  width: "14",
  height: "14",
  "aria-hidden": "true"
}
const _hoisted_10 = ["d"]
const _hoisted_11 = { class: "qualification-dialog__scroll" }
const _hoisted_12 = {
  class: "qualification-dialog__intro",
  "data-testid": "qualification-blocked-message"
}
const _hoisted_13 = { class: "qualification-dialog__body" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "qualification-dialog__section" }, "O que falta", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "qualification-dialog__section" }, "Também falta (permitiria pré-alocação)", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "qualification-dialog__note" }, [
  /*#__PURE__*/_createTextVNode(" Como há pelo menos um critério que "),
  /*#__PURE__*/_createElementVNode("strong", null, "bloqueia"),
  /*#__PURE__*/_createTextVNode(", a pré-alocação não está disponível para este médico. ")
], -1))
const _hoisted_17 = {
  key: 2,
  class: "qualification-dialog__note",
  "data-testid": "qualification-blocked-fallback"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "qualification-dialog__help" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" O médico já vê essa pendência no "),
    /*#__PURE__*/_createElementVNode("strong", null, "Drive do Médico"),
    /*#__PURE__*/_createTextVNode(", no app. Assim que o Time de Documentação aprovar o documento, a alocação fica liberada. ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "Não há liberação manual: a regra vem da Qualificação exigida da escala.")
], -1))
const _hoisted_19 = { class: "qualification-dialog__footer" }

import { computed } from 'vue'
import { mdiAccountOutline, mdiShieldLockOutline } from '@mdi/js'

import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import { QualificationOnFail } from '@/types/qualification-eligibility.types'
import type { EligibilityReason } from '@/types/qualification-eligibility.types'

import QualificationMissingList from './QualificationMissingList.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'QualificationBlockedDialog',
  props: {
    modelValue: { type: Boolean },
    doctorName: {},
    missing: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;




const hasBlocking = computed(() =>
  props.missing.some((reason) => reason.onFail === QualificationOnFail.BLOCK)
)
// Sem item que bloqueia (corpo inesperado), tudo vai para "O que falta".
const blocking = computed(() =>
  hasBlocking.value
    ? props.missing.filter((reason) => reason.onFail === QualificationOnFail.BLOCK)
    : props.missing
)
const preAllocatable = computed(() =>
  hasBlocking.value
    ? props.missing.filter((reason) => reason.onFail === QualificationOnFail.PRE_ALLOCATE)
    : []
)

function close(): void {
  emit('update:modelValue', false)
}

function onDialogUpdate(open: boolean): void {
  if (!open) close()
}

return (_ctx: any,_cache: any) => {
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.modelValue,
    "max-width": "640",
    scrollable: "",
    attach: "#app",
    scrim: "rgba(22, 22, 29, 0.55)",
    "aria-labelledby": "qualification-blocked-title",
    "data-testid": "qualification-blocked-dialog",
    "onUpdate:modelValue": onDialogUpdate
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            (_openBlock(), _createElementBlock("svg", _hoisted_4, [
              _createElementVNode("path", {
                d: _unref(mdiShieldLockOutline),
                fill: "currentColor"
              }, null, 8, _hoisted_5)
            ]))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            (_ctx.doctorName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_9, [
                    _createElementVNode("path", {
                      d: _unref(mdiAccountOutline),
                      fill: "currentColor"
                    }, null, 8, _hoisted_10)
                  ])),
                  _createTextVNode(" " + _toDisplayString(_ctx.doctorName), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.doctorName ?? 'O médico') + " não atende à Qualificação exigida desta escala. ", 1),
          _createElementVNode("div", _hoisted_13, [
            (blocking.value.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_14,
                  _createVNode(QualificationMissingList, { missing: blocking.value }, null, 8, ["missing"])
                ], 64))
              : _createCommentVNode("", true),
            (preAllocatable.value.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_15,
                  _createVNode(QualificationMissingList, { missing: preAllocatable.value }, null, 8, ["missing"]),
                  _hoisted_16
                ], 64))
              : _createCommentVNode("", true),
            (!_ctx.missing.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_17, " Não foi possível listar o que falta agora. Confira os documentos do médico. "))
              : _createCommentVNode("", true),
            _hoisted_18
          ])
        ]),
        _createElementVNode("footer", _hoisted_19, [
          _createVNode(FilledButton, {
            height: "44px",
            width: "140px",
            color: "primary",
            class: "bg-primary30",
            "data-testid": "qualification-blocked-ok",
            onClick: close
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Entendi ")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})